export default __webpack_public_path__ + "static/img2@2x-1f2150bd46f7eecd363f8ce6ad757831.jpg";